<template>
	<v-dialog persistent max-width="764px" ref="createDialog" v-model="dialog">
		<v-form lazy-validation ref="form" v-model="valid">
			<v-card>
				<v-card-title>
					<span class="text-h5">Create Brand SKU</span>
				</v-card-title>
				<v-card-text>
					<v-row>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="errors && errors.message">
                            <v-alert dense outlined type="error" class="mb-0"><span v-text="errors.message"></span></v-alert>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
							<v-text-field dense label="SKU Name*" :rules="rules.name" :error-messages="errors.name" v-model="object.name"></v-text-field>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
							<v-text-field dense label="Retail Price*" :rules="rules.price" :error-messages="errors.price" v-model="object.price"></v-text-field>
						</v-col>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <v-file-input ref="file" label="Image File*" show-size accept="images/jpg, images/jpeg, images/png" :rules="rules.file" :error-messages="errors.file" @change="readFileData"></v-file-input>
                            <small class="red--text">Note: Only accepts PNG, JPG, JPEG file (Less than 1 MB). Recommended dimension is 200x200.</small>
                        </v-col>
					</v-row>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <small class="red--text">* Required field</small>
                        </v-col>
                    </v-row>
				</v-card-text>
				<v-card-actions class="pl-4 pr-4">
					<v-spacer></v-spacer>
					<v-btn text @click="close">Close</v-btn>
					<v-btn text color="primary" :loading="loading" @click="create">Create</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>


<script>

import { copyObject } from '@/utils/helper'

export default {
	name: 'ProjectSKUCreateDialog',
	data() {
		return {
			dialog: false,
			valid: true,
			loading: false,
			object: {
                project: this.$route.params.id,
                name: '',
                file: ''
			},
			rules: {
                name: [
                    (value) => !!value || 'SKU name is required',
                    (value) => value && value.length >= 2 && value.length <= 100 || 'SKU name must be between 6 and 100 characters'
                ],
                price: [
                    (value) => {
                        if(!value){
                            return 'Retail price is required'
                        }

                        if(value && isNaN(value)){
                            return "Retail Price must be a numeric value"
                        }

                        return true
                    }
                ],
                file: [
                    (value) => {
                        if(!value) {
                            return 'Image file is required'
                        }

                        var fileSize = Math.ceil(value.size / 1024)

                        if(fileSize > 1024) {
                            return 'Image file must less than 1MB'
                        }

                        return true
                    }
                ]
			},
			errors: {}
		}
	},
	computed: {
		createDialog() {
			return this.$refs.createDialog
		},
		form() {
			return this.$refs.form
		}
	},
	methods: {
		open: function() {
			this.dialog = true
		},
		close: function() {
			this.dialog = false
			this.loading = false
			this.object = { project: this.$route.params.id, name: '', price: '', file: '' }
			this.errors = {}
			this.form.reset()
			this.form.resetValidation()
		},
        updateObject: function(item) {
            this.object = item
        },
		create: function() {
			if(this.form.validate()){
				this.loading = true
                const object = copyObject(this.object)

                this.$store.dispatch('epanel/project/createProjectSKU', object).then((response) => {
                    this.close()
                    this.$emit('created', { message: response.message })
                }).catch((errors) => {
                    this.errors = errors.data?errors.data.errors:errors
                    this.loading = false
                })
			}
		},
        readFileData: function(file) {
            if(!file){
                return
            }

            var reader = new FileReader()
            reader.readAsDataURL(file)
            reader.addEventListener('load', (e) => {
                this.object.file = e.target.result
            })

        }
	}
}

</script>